"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ServiceRegistry = _interopRequireDefault(require("../util/ServiceRegistry"));
var _CallbackTypes = _interopRequireDefault(require("../constants/CallbackTypes"));
var _ApiConstants = _interopRequireDefault(require("../constants/ApiConstants"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2020 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
const DEFAULT_USER_INFO = {
  name: "Guest",
  firstName: "",
  lastName: "",
  email: "",
  isAdmin: false,
  showUpsell: false,
  isDefaultApp: false,
  enableDefaultAppReminder: false
};
const logInfo = (err, ref, serviceRegistry) => {
  const loggingService = serviceRegistry.getService("LoggingService");
  loggingService.info("UserApi", ref, err);
};
const maskUserInfo = (userInfo, serviceRegistry) => {
  const maskedUser = _objectSpread(_objectSpread({}, DEFAULT_USER_INFO), userInfo);
  maskedUser.userLocale = serviceRegistry.getService("AppStore").configStore.getConfig().locale || "en-US";
  const showProfilePicture = serviceRegistry.getService("AppStore").configStore.getConfig().noRestriction;
  if (showProfilePicture === false && maskedUser.pictureURL) {
    delete maskedUser.pictureURL;
  }
  return maskedUser;
};

/**
 * @class
 * @description
 * The class provides methods related to user profile and their settings.
 */
class UserApi {
  constructor() {
    /**
     * @method
     * @description
     * It provides the interface to set the user setting information
     *
     *
     * @returns Returns promise which resolve if successful
     * @param userSetting
     */
    this.setUserSettings = userSetting => new Promise((resolve, reject) => {
      const callbackService = _ServiceRegistry.default.getService("CallbackService");
      if (callbackService.hasCallback(_CallbackTypes.default.SET_USER_SETTING_API) && callbackService.hasCallback(_CallbackTypes.default.GET_USER_SETTING_API)) {
        const setSettingCallback = callbackService.getCallback(_CallbackTypes.default.SET_USER_SETTING_API);
        setSettingCallback(userSetting).then(response => {
          if (response.code === _ApiConstants.default.API_RESPONSE.SUCCESS) {
            resolve();
          } else {
            logInfo(response, "Invalid setUserSettings response.", _ServiceRegistry.default);
            reject();
          }
        }).catch(err => {
          logInfo(err, "Promise rejected for setUserSettings.", _ServiceRegistry.default);
          reject();
        });
      } else {
        this.settingStorage = userSetting;
        resolve();
      }
    });
    this.settingStorage = {};
    this.fetchingUserProfile = false;
    this.userProfileDetails = null;
  }
  initialize() {
    return this.getUserProfile();
  }

  /**
   * @method
   * @description
   * It provides the interface to get user profile information.
   *
   * @returns Returns promise which resolve with userInfo
   */
  getUserProfile() {
    return new Promise((resolve, reject) => {
      const callbackService = _ServiceRegistry.default.getService("CallbackService");
      const appStore = _ServiceRegistry.default.getService("AppStore");
      let userInfo = appStore.getUserInfo();
      if (userInfo && Object.keys(userInfo).length > 0) {
        resolve(userInfo);
      } else if (callbackService.hasCallback(_CallbackTypes.default.GET_USER_PROFILE_API)) {
        if (!this.fetchingUserProfile) {
          this.fetchingUserProfile = true;
          const userProfileCallback = callbackService.getCallback(_CallbackTypes.default.GET_USER_PROFILE_API);
          userProfileCallback().then(response => {
            if (response.code === _ApiConstants.default.API_RESPONSE.SUCCESS) {
              userInfo = response.data.userProfile;
              appStore.setUserInfo(maskUserInfo(userInfo, _ServiceRegistry.default));
              const analyticsProviderService = _ServiceRegistry.default.getService("AnalyticsProviderService");
              const workflow = "UserProfile";
              const subcategory = "Properties";
              if (userInfo.isAdmin) {
                analyticsProviderService.logEvent({
                  workflow,
                  subcategory,
                  type: "isAdmin"
                });
              }
              if (userInfo.showUpsell) {
                analyticsProviderService.logEvent({
                  workflow,
                  subcategory,
                  type: "showUpsell"
                });
              }
              if (userInfo.isDefaultApp) {
                analyticsProviderService.logEvent({
                  workflow,
                  subcategory,
                  type: "isDefaultApp"
                });
              }
              this.userProfileDetails = appStore.getUserInfo();
              resolve(appStore.getUserInfo());
            } else {
              this.fetchingUserProfile = false;
              logInfo(response, "Invalid getUserInfo response.", _ServiceRegistry.default);
              reject();
            }
          }).catch(err => {
            this.fetchingUserProfile = false;
            logInfo(err, "Promise rejected for getUserInfo.", _ServiceRegistry.default);
            reject();
          });
        } else {
          // API call to get user profile info is already in progress, wait for it to finish
          const checkInterval = setInterval(() => {
            if (this.userProfileDetails) {
              clearInterval(checkInterval);
              resolve(this.userProfileDetails);
            }
          }, 100);
        }
      } else {
        resolve(maskUserInfo({}, _ServiceRegistry.default));
      }
    });
  }

  /**
   * @method
   * @description
   * It provides the interface to get user setting information.
   *
   * @returns Returns promise which resolve with usersettings
   */
  getUserSettings() {
    return new Promise((resolve, reject) => {
      const callbackService = _ServiceRegistry.default.getService("CallbackService");
      if (callbackService.hasCallback(_CallbackTypes.default.GET_USER_SETTING_API)) {
        const getSettingCallback = callbackService.getCallback(_CallbackTypes.default.GET_USER_SETTING_API);
        getSettingCallback().then(response => {
          if (response.code === _ApiConstants.default.API_RESPONSE.SUCCESS) {
            resolve(response.data.setting);
          } else {
            logInfo(response, "Invalid getUserSettings response", _ServiceRegistry.default);
            reject();
          }
        }).catch(err => {
          logInfo(err, "Promise rejected for getUserSettings.", _ServiceRegistry.default);
          reject();
        });
      } else {
        resolve(this.settingStorage);
      }
    });
  }
}
var _default = exports.default = UserApi;